import { Injectable } from '@angular/core';
import { CustuomtoastserviceService } from './custuomtoastservice.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private toaster: CustuomtoastserviceService) {}

  handleError(err: any): void {
    if (!err) return;

    if (err.status === 400 && err.error?.errors) {
      const validationMessages = err.error.errors
        .map((error: any) => `${error.field}: ${error.message}`)
        .join('\n');

      this.toaster.error(validationMessages);
    } else {
      this.toaster.error(err.error?.detail || 'An unexpected error occurred.');
    }
  }
}
